import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import SEO from "./seo"

const Privacy = ({ title, children }) => {
  return (
    <>
      <SEO title={title} />
      <Link to="/privacy-en/">English</Link>
      {` `}
      <Link to="/privacy-ja/">日本語</Link>
      <div className="hero">
        <h1 className="title">{title}</h1>
        <div className="description">{children}</div>
      </div>

      <style jsx>{`
        .hero {
          width: 100%;
          color: #333;
        }
        .title {
          margin: 0;
          width: 100%;
          padding-top: 30px;
          line-height: 1.15;
          font-size: 48px;
          text-align: center;
        }
        .description {
          max-width: 880px;
          margin: 30px auto 30px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          white-space: "pre-line";
        }
      `}</style>
    </>
  )
}

Privacy.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
}

Privacy.defaultProps = {
  title: ``,
  description: ``,
}

export default Privacy
